import type { TimelineEventTypes } from '@ViewModels';
import { StyleDeclarationValue } from 'aphrodite';
import { CheckboxFilterDropdown, ICheckboxFilterOption } from '../../../CheckboxFilterDropdown';

export interface ITimelineFilterOption extends ICheckboxFilterOption {
	types: TimelineEventTypes[];
}

export interface ITimelineFilterProps {
	options: ITimelineFilterOption[];
	selectedIds: string[];
	onCommit: (selectedIds: string[]) => void;
	styles?: StyleDeclarationValue[];
}

export function TimelineFilter({ options, selectedIds, onCommit, styles = [] }: ITimelineFilterProps) {
	return (
		<CheckboxFilterDropdown
			ariaLabel='Filter timeline by type'
			onCommit={onCommit}
			options={options}
			selectedIds={selectedIds}
			styles={styles}
		/>
	);
}
